export const INCOME_REGISTRATION = "INCOME_REGISTRATION";
export const JURPERSON_ADD = "JURPERSON_ADD";
export const CLIENT_REGISTRATION_UNBIND = "CLIENT_REGISTRATION_UNBIND";
export const CLIENT_REGISTRATION_DELETE = "CLIENT_REGISTRATION_DELETE";
